export const getCurrentTimeWithTimezone = (): string => {
  const now = new Date()
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone

  return `${now.toISOString()}|${tz}`
}
